import React, { useEffect, useState } from "react";
import PageTitle from "../../components/shared/PageTitle";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
export default function Faq() {
  const [currentIndex, setCurrentIndex] = useState(null);
  const { t } = useTranslation();

  const [data, setData] = useState(null);
  const locale = useSelector((state) => state.locale.locale);
  useEffect(() => {
    setData(t("faq", { returnObjects: true }));
  }, [t, locale]);
  return (
    <div className="text-white px-4 relative z-30">
      <div className="relative">
        <PageTitle
          title={locale === "en" ? "Frequently Asked Question" : "Tanya Jawab"}
        />
      </div>
      <div className="pt-80 bg-black 2xl:px-0 md:px-14 px-0 ">
        <div className="bg-black container mx-auto w-full font-ttFirsNeue text-white">
          <div className="flex flex-col">
            {data?.map((value, index) => (
              <div
                key={value.title}
                className="border-b border-neutral-600 w-full scroll-m-20 md:scroll-m-36 lg:scroll-m-20 xl:scroll-m-36"
                id={`faq-${index}`}
              >
                <button
                  className="pb-4 pt-10 w-full flex items-center justify-between"
                  onClick={() => {
                    if (index === currentIndex) {
                      setCurrentIndex(null);
                    } else {
                      setCurrentIndex(index);
                      setTimeout(() => {
                        document
                          .getElementById(`faq-${index}`)
                          ?.scrollIntoView({ behavior: "smooth" });
                      }, 1);
                    }
                  }}
                >
                  <h1 className="md:text-xl text-lg uppercase">
                    {value.title}
                  </h1>
                  <div>
                    {index === currentIndex ? (
                      <MinusIcon width={24} className="text-red-500" />
                    ) : (
                      <PlusIcon width={24} className="text-white" />
                    )}
                  </div>
                </button>
                <div>
                  <div
                    className={`mb-10 w-full ${
                      index === currentIndex ? "block" : "hidden"
                    }`}
                  >
                    <ul className="space-y-4 w-full">
                      {value.data.map((data, i) => (
                        <li key={data.question} className="space-y-2 w-full">
                          <h2 className="font-medium text-md">
                            {i + 1}. {data.question}
                          </h2>
                          <div
                            dangerouslySetInnerHTML={{ __html: data?.answer }}
                            className="font-light text-neutral-200"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
